import { TitleRow } from 'components/titleRow'
import { useOrganizations } from 'hooks/admin/useOrganizations'
import React from 'react'

import { OrganizationForm } from './form/organizationForm'
import { Container, ContainerWrapper } from './organizations.style'
import { OrganizationsTable } from './table/organizationsTable'

export const OrganizationsAdmin: React.FC = () => {
    const { tableConfig, handleSearch, handleEdit, handleOpenDialog, handleCloseDialog, isDialogVisible, selectedOrganization } =
        useOrganizations()

    return (
        <Container>
            <ContainerWrapper>
                <TitleRow
                    configData={tableConfig.titleRow}
                    onSearch={handleSearch}
                    isDialogVisible={isDialogVisible}
                    openDialog={handleOpenDialog}
                    closeDialog={handleCloseDialog}
                >
                    <OrganizationForm initialData={selectedOrganization} onClose={handleCloseDialog} />
                </TitleRow>
                <OrganizationsTable configData={tableConfig.titleRow} handleEdit={handleEdit}>
                    <OrganizationForm initialData={selectedOrganization} onClose={handleCloseDialog} />
                </OrganizationsTable>
            </ContainerWrapper>
        </Container>
    )
}
